import SharedAsset from '@zenbusiness/common-components/SharedAsset';
import Title from '@zenbusiness/common-components/Title';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';

import superstyled from '#client/pages/EducationStudio/utils/superstyled';

import { BorderedBox } from '../BorderedBox';

export const LeftSideWord = superstyled({
  tag: SharedAsset,
  styles: ({ theme }) => ({
    position: 'fixed',
    top: 0,
    left: 0,
    transformOrigin: 'top left',
    transform: 'rotate(45deg) translate(0%, -40%)',
    [theme.breakpoints.up('md')]: {
      transform: 'none',
      width: '30%',
      top: '0',
      left: '0',
      height: '100vh',
      float: 'left'
    }
  })
});

export const RightSideWord = superstyled(({
  tag: SharedAsset,
  styles: ({ theme }) => ({
    position: 'fixed',
    bottom: 0,
    right: 0,
    transformOrigin: 'bottom right',
    transform: 'rotate(45deg) translate(0%, 40%)',
    [theme.breakpoints.up('md')]: {
      transform: 'none',
      width: '30%',
      top: '0',
      right: '0',
      height: '100vh',
      float: 'right'
    }
  })
}));
export const Sticker = superstyled({
  tag: SharedAsset,
  styles: ({ theme }) => ({
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'block',
      position: 'fixed',
      left: '80%',
      right: '0%',
      top: '30%',
      bottom: '0%',
      transform: 'scale(0.8) rotate(-30deg)'
    }
  })
});
export const TitleContainer = superstyled({
  tag: BorderedBox,
  styles: ({ theme }) => ({
    backgroundColor: theme.palette.focus00.main,
    width: 'fit-content',
    margin: '2.5rem auto 0',
    padding: '1rem',
    [theme.breakpoints.up('sm')]: {
      margin: '4rem auto 0',
      padding: '1.25rem 1.5rem'
    },
    [theme.breakpoints.up('md')]: {
      borderRadius: '1.625rem'
    }
  })
});

export const LessonCompleteTitle = superstyled({
  tag: Title,
  styles: ({ theme }) => ({
    [theme.breakpoints.down('md')]: {
      fontSize: '4rem'
    }
  })
});

export const BottomTitle = superstyled({
  tag: Title,
  styles: {
    margin: '0 0 0 3.125rem'
  }
});

export const LottieContainer = superstyled({
  tag: Grid,
  styles: ({ theme }) => ({
    margin: '0 auto 1.5rem',
    [theme.breakpoints.up('sm')]: {
      margin: '1rem auto 1.5rem'
    }
  })
});
export const PrimaryButton = superstyled({
  tag: Button,
  styles: ({ theme }) => ({
    ...theme.typography.button_medium,
    width: '16.5rem',
    padding: '1.25rem 1.5rem',
    backgroundColor: theme.palette.focus90.main,
    color: theme.palette.focus00.main,
    borderRadius: '1rem',
    textTransform: 'none'
  })
});

export const SecondaryButton = superstyled({
  tag: Button,
  theme: ({ theme }) => ({
    ...theme.typography.button_medium,
    width: '16.5rem',
    padding: '1.25rem 1.5rem',
    backgroundColor: theme.palette.focus00.main,
    color: theme.palette.focus90.main,
    borderRadius: '1rem',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#27ADB3'
    }
  })
});
